module.exports = __webpack_public_path__ + "static/img/invest-TMT6.e366c82.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/investCase/invest-TMT6.jpg
// module id = gkiB
// module chunks = 0